import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfoResponse } from 'edu-auth/dist/responses/user-info-response';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'profile-button',
  templateUrl: './profile-button.component.html',
  styleUrls: ['./profile-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProfileButtonComponent implements OnInit {
  constructor(
    private _loginService: LoginService,
    private _router: Router,
  ) {}
  name: string;
  info: UserInfoResponse;
  ngOnInit(): void {
    this.info = this._loginService.userInfo;
    this.name = this.info.fullName;
  }

  public get initials(): string {
    if (this.name == null) {
      return '';
    }
    let fullName = this.name.trim();
    let names = fullName.split(' ');
    return names[0][0] + names[names.length - 1][0];
  }

  async logout() {
    // OIDC deployment: LOCAL logout — clear the translator's session and let
    // signOutToMainApp() redirect the browser to the QLM account (main app). It performs
    // the redirect itself, so we must NOT router.navigate here (that would race the
    // redirect, and the /login page's silent re-auth could win and sign the user back in).
    if (this._loginService.logoutRedirects) {
      this._loginService.signOutToMainApp();
      return;
    }
    // Legacy cookie path: clear cookies and go to the translator's own login page.
    await this._loginService.logout();
    // Full page load so all in-memory service state is discarded too.
    window.location.assign('/login');
  }
  async goToProfile() {
    this._router.navigate(['/portal/students/dashboard']);
  }

  navigateToChangePassword() {
    window.open(
      `https://www${environment.domain}/portal/home/change-password`,
      '_blank',
    );
  }
}
